import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Col,
  Progress,
  Row,
} from "reactstrap";

const OccupancyWidget = ({
  inventory = [],
}) => {

  let totalRooms = 0;
  let occupiedRooms = 0;
  let availableRooms = 0;
  let blockedRooms = 0;

  inventory.forEach(room => {

    room?.inventory?.forEach(inv => {

      totalRooms +=
        Number(inv.totalRooms || 0);

      occupiedRooms +=
        Number(inv.bookedRooms || 0);

      availableRooms +=
        Number(inv.availableRooms || 0);

      blockedRooms +=
        Number(inv.blockedRooms || 0);

    });

  });

  const occupancy =
    totalRooms > 0
      ? (
          (occupiedRooms /
            totalRooms) *
          100
        ).toFixed(2)
      : 0;

  return (
    <Col xl={4}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <h4 className="card-title mb-0">
            Occupancy Analytics
          </h4>
        </CardHeader>

        <CardBody>

          <div className="text-center mb-4">

            <h1 className="display-5 fw-bold text-primary">
              {occupancy}%
            </h1>

            <p className="text-muted mb-2">
              Current Occupancy
            </p>

            <Progress
              value={occupancy}
              color={
                occupancy >= 80
                  ? "success"
                  : occupancy >= 50
                  ? "warning"
                  : "danger"
              }
              style={{
                height: "12px",
              }}
            />

          </div>

          <Row>

            <Col xs={6}>
              <div className="border rounded p-3 text-center mb-3">
                <h4 className="mb-1 text-primary">
                  {occupiedRooms}
                </h4>

                <small className="text-muted">
                  Occupied
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center mb-3">
                <h4 className="mb-1 text-success">
                  {availableRooms}
                </h4>

                <small className="text-muted">
                  Available
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h4 className="mb-1 text-warning">
                  {blockedRooms}
                </h4>

                <small className="text-muted">
                  Blocked
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h4 className="mb-1">
                  {totalRooms}
                </h4>

                <small className="text-muted">
                  Total Rooms
                </small>
              </div>
            </Col>

          </Row>

        </CardBody>
      </Card>
    </Col>
  );
};

export default OccupancyWidget; 